import { compose } from "redux";
import React, { PureComponent } from "react";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Field } from "redux-form/immutable";

import { BasePageTitle } from "altus-ui-components";

import { Format } from "app/app.constants";
import { formatDate } from "utils/format.util";
import { UPDATE_EMPLOYEE_FORM } from "features/planner/employee/employee.constants";
import ReadOnlyField from "app/components/form/ReadOnlyField";
import TextField from "app/components/form/TextField";

class PersonaliaForm extends PureComponent {
  render() {
    const { classes } = this.props;

    return (
      <Grid
        container
        direction="column"
        item
        xs={12}
        lg={6}
        className={classes.root}
      >
        <Grid item>
          <BasePageTitle title="Personalia" />
        </Grid>
        <Grid item>
          <Field
            label="Name"
            defaultValue="-"
            component={ReadOnlyField}
            name={UPDATE_EMPLOYEE_FORM.DISPLAY_NAME}
          />
        </Grid>
        <Grid item>
          <Field
            label="Address"
            defaultValue="-"
            component={ReadOnlyField}
            name={UPDATE_EMPLOYEE_FORM.ADDRESS}
          />
        </Grid>
        <Grid container>
          <Grid item xs={6} style={{ paddingRight: 16 }}>
            <Field
              label="City"
              defaultValue="-"
              component={ReadOnlyField}
              name={UPDATE_EMPLOYEE_FORM.CITY}
            />
          </Grid>
          <Grid item xs={6}>
            <Field
              label="Zip code"
              defaultValue="-"
              component={ReadOnlyField}
              name={UPDATE_EMPLOYEE_FORM.ZIP_CODE}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Field
            defaultValue="-"
            label="E-mail (work)"
            component={ReadOnlyField}
            name={UPDATE_EMPLOYEE_FORM.EMAIL_WORK}
          />
        </Grid>
        <Grid container>
          <Grid item xs={6} style={{ paddingRight: 16 }}>
            <Field
              defaultValue="-"
              label="Phone"
              component={ReadOnlyField}
              name={UPDATE_EMPLOYEE_FORM.PHONE}
            />
          </Grid>
          <Grid item xs={6}>
            <Field
              defaultValue="-"
              label="Cell phone"
              component={ReadOnlyField}
              name={UPDATE_EMPLOYEE_FORM.CELL_PHONE}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={6} style={{ paddingRight: 16 }}>
            <Field
              defaultValue="-"
              label="Nationality"
              component={ReadOnlyField}
              name={UPDATE_EMPLOYEE_FORM.NATIONALITY}
            />
          </Grid>
          <Grid item xs={6}>
            <Field
              defaultValue="-"
              label="Date of birth"
              component={ReadOnlyField}
              name={UPDATE_EMPLOYEE_FORM.DATE_OF_BIRTH}
              formatDate={date => formatDate(date, Format.date)}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={6} style={{ paddingRight: 16 }}>
            <Field
              defaultValue="-"
              label="Hired from"
              component={ReadOnlyField}
              name={UPDATE_EMPLOYEE_FORM.HIRED_FROM}
              formatDate={date => formatDate(date, Format.date)}
            />
          </Grid>
          <Grid item xs={6}>
            <Field
              defaultValue="-"
              label="Hired to"
              component={ReadOnlyField}
              name={UPDATE_EMPLOYEE_FORM.HIRED_TO}
              formatDate={date => formatDate(date, Format.date)}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Field
            label="Notes"
            name={UPDATE_EMPLOYEE_FORM.NOTES}
            rows={3}
            component={TextField}
            multiline
          ></Field>
        </Grid>
      </Grid>
    );
  }
}

const styles = () => ({
  root: {},
});

export default compose(withStyles(styles))(PersonaliaForm);
